import { useTranslator } from "../../i18n/context.js";
import { usePlayer } from "../../player/context.js";
import { logMissingFeature } from "@videojs/core/dom";
import { translateText } from "@videojs/core/i18n";
import { useCallback, useState } from "react";
//#region src/ui/hooks/create-radio-options-hook.ts
/** Creates framework adapter mechanics shared by media-backed radio option hooks. */
function createRadioOptionsHook({ name, feature, selector, createCore }) {
	return function useRadioOptions(props) {
		"use no memo";
		const media = usePlayer(selector);
		const t = useTranslator();
		const [core] = useState(createCore);
		core.setProps(props ?? {});
		const setValue = useCallback((value) => core.selectValue(media, value), [core, media]);
		if (!media) {
			logMissingFeature(name, selector.displayName ?? feature);
			return null;
		}
		core.setMedia(media);
		const state = core.getState();
		const options = state.options.map((option) => {
			const { label, labelParams, disabled, ...rest } = option;
			return {
				...rest,
				label: translateText(label, t, labelParams),
				disabled: state.disabled || disabled
			};
		});
		return {
			state,
			label: translateText(core.getLabel(state), t, core.getLabelParams?.(state)),
			value: state.value,
			selectedLabel: options.find((option) => option.value === state.value)?.label ?? "",
			options,
			disabled: state.disabled,
			hidden: state.hidden,
			setValue
		};
	};
}
//#endregion
export { createRadioOptionsHook };

//# sourceMappingURL=create-radio-options-hook.js.map